var CustomerEmailView = (function (_IsAuthorized) {

    var recaptchaReady;

    function validateEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }


    var initializeTC = function (_tcOnChange, _emailOnChange) {

        var consent = $('[id$="siteData"]').data('consent');

        var switchTC = new Switch({
            defaultValue: consent.RATermsAndConditionCheckboxTicked || null,
            trueText: GetPageTemplate('js_Yes'),
            falseText: GetPageTemplate('js_No'),
            label: GetPageTemplate('_consentWithTCText'),
            testClass: 'test-guest-tac-switch',
            onChanged: _tcOnChange
        });
        var switchEmail = new Switch({
            defaultValue: consent.RAReceiveEmailsCheckboxTicked || null,
            trueText: GetPageTemplate('js_Yes'),
            falseText: GetPageTemplate('js_No'),
            label: GetPageTemplate('_consentWithEmailsText'),
            testClass: 'test-guest-emails-switch',
            onChanged: _emailOnChange
        });

        return {
            switchTC: switchTC,
            switchEmail: switchEmail
        }
    }

    function _signin(data) {
        if (data === null) return;

        var def = new $.Deferred();

        if (!recaptchaReady) {
            recaptchaReady = recaptcha.init('recaptcha');
        }

        recaptchaReady
            .done(function () {
                recaptcha.execute().done(function (token) {
                    data.captchaResponse = token;
                    data.userName = data.email;
                    api.signin(data, { wait: true, hideErrors: false, disableErrorEmitter: true })
                        .done(function () {
                            location.reload();
                            def.resolve();
                        })
                        .fail(def.reject);
                });
            })
            .fail(function () {
                api.signinCustomet(data, { wait: true, hideErrors: true, disableErrorEmitter: true })
                    .done(function () {
                        loginSuccess();
                        def.resolve();
                    })
                    .fail(def.reject);
            });
        return def.promise();
    }

    function setGuestEmail(email) {
        window.localStorage && localStorage.setItem('GuestEmail', email);
    }
    function getGuestEmail() {
        return window.localStorage && localStorage.getItem('GuestEmail') || '';
    }

    var CustomerEmailView = Backbone.View.extend({
        el: '@customerEmail',
        events: {
            'blur input': '_validate',
            'focus input': '_focus',
            'mouseup input': '_clearedByCross',
            'click @displayLoginForm': '_displayLoginForm'
        },

        initialize: function () {
            _.bindAll(this);

            this.$agreeTC = $('@customerAgreeWithTC');
            this.$agreeEmails = $('@customerReceiveEmails');

            if (_IsAuthorized()) {
                this.$el.remove();
                this.$agreeTC.remove();
                this.$agreeEmails.remove();
            } else {

                this.$el.html($.tmpl('guest_auth'));

                var consent = $('[id$="siteData"]').data('consent');
                this.$field = this.$('input');
                this.$field.keyFilter();
                this.switchTC = new Switch({
                    defaultValue: consent.RATermsAndConditionCheckboxTicked || null,
                    trueText: GetPageTemplate('js_Yes'),
                    falseText: GetPageTemplate('js_No'),
                    label: GetPageTemplate('_consentWithTCText'),
                    testClass: 'test-guest-tac-switch',
                    onChanged: this._tcOnChange
                });
                this.switchEmail = new Switch({
                    defaultValue: consent.RAReceiveEmailsCheckboxTicked || null,
                    trueText: GetPageTemplate('js_Yes'),
                    falseText: GetPageTemplate('js_No'),
                    label: GetPageTemplate('_consentWithEmailsText'),
                    testClass: 'test-guest-emails-switch',
                    onChanged: this._emailOnChange
                });
                this.switchTC.appendTo(this.$agreeTC);
                this.switchEmail.appendTo(this.$agreeEmails);

                this._initLoginDescription();
            }
        },

        _initLoginDescription: function () {
            var loginLinkHtml = '<a href="#" role="displayLoginForm" class="link-decor link-decor__small test_guest_display_login_form">Log In</a>';
            this.$('@guest-login-description').html(GetPageTemplate('_GuestCheckoutLoginDescription').replace(/\[\[log in\]\]/gi, loginLinkHtml));
        },

        _tcOnChange: function () {
            if (this.switchTC) {
                var val = this.switchTC.getValue();
                window.app && app.event && app.event.userAgreementsTermsAndCondition(val);
                this.switchTC.toggleWarningClass(false);
            }
        },

        _emailOnChange: function () {
            if (this.switchEmail) {
                var val = this.switchEmail.getValue();
                window.app && app.event && app.event.userAgreementsReceivePromotional(val);
                this.switchEmail.toggleWarningClass(false);
            }
        },

        _displayLoginForm: function (e) {
            e.preventDefault();
            window.app && app.event && app.event.logIn();
            window.landingForm && landingForm.showPopup({ closeBtn: true, mode: landingForm.mode.Login })
                .done(function () {
                    landingForm.destroy();
                    location.reload();
                });
        },

        _validate: function () {
            this.$field.toggleClass('errorField', !validateEmail(this.$field.val()));
        },

        _focus: function () {
            this.$field.removeClass('errorField');
        },

        _clearedByCross: function (e) {
            var _this = this;
            if (e.currentTarget.value === "") return;
            setTimeout(function () {
                if (e.currentTarget.value === "") _this._validate();
            }, 0);
        },

        getCustomerData: function () {
            var validateEmail = this._validate();
            var email = !validateEmail && null || this.$field.val();

            var name = '';

            if (app.models.delivery.current.isActive) {
                name = app.models.delivery.current.get('Name');
            } else if (app.models.delivery.decoration.isActive) {
                var models = app.models.delivery.decoration.where({ 'Name': 'Name' });
                name = models[0] && models[0].get('Value') || '';
            }

            var tcAccepted = this.switchTC.getValue();
            var emailsAccepted = this.switchEmail.getValue();

            var message = [];

            this.switchTC.toggleWarningClass(!tcAccepted);
            this.switchEmail.toggleWarningClass(emailsAccepted === null);

            !tcAccepted && message.push('- ' + GetPageTemplate('_consentWithRegistrationTermsWarning'));
            emailsAccepted === null && message.push('- ' + GetPageTemplate('_consentWithRegistrationEmailWarning'));

            if (message.length > 0) {
                kos.dialog.error({ title: '', message: message.join('</br>') });
            }

            return {
                email: email,
                name: name,
                parameters: {
                    tcAccepted: tcAccepted,
                    emailsAccepted: emailsAccepted
                },
                isValid: email && tcAccepted && emailsAccepted !== null
            };
        }
    });


    var TwoStepsModel = Backbone.Model.extend({
        defaults: {
            email: null,
            token: null,
            exists: null,
            isValid: null
        },

        _receiveToken: function () {
            if (this._timeout) {
                clearTimeout(this._timeout);
            }

            if (this.get('isValid') === true && this.get('email') !== '') {
                var _this = this;

                this._timeout = setTimeout(function () {

                    setGuestEmail(_this.get('email'));

                    api.getTokenByEmail({ email: _this.get('email') }).done(function (result) {
                        var data = result.Value;
                        _this.set('exists', data ? data.Exists : null);
                        _this.set('token', data ? data.Token : null);
                    });
                }, 1000);
            }
        },

        signin: function (password, tcAccepted, emailsAccepted) {
            var $def = new $.Deferred();

            if (!recaptchaReady) {
                recaptchaReady = recaptcha.init('recaptcha');
            }

            var _this = this;
            var invitedBy = window.cookie && cookie.get('invitedBy') || null;

            recaptchaReady.done(function() {
                recaptcha.execute().done(function(token) {
                    api.signInByToken({
                        token: _this.get('token'),
                        password: password,
                        parameters: {
                            tcAccepted: tcAccepted,
                            emailsAccepted: emailsAccepted
                        },
                        invitedBy: invitedBy || queryParams.get("invitedBy") || null,
                        referredBy: queryParams.get("referredBy") || null,
                        voucherID: queryParams.get("voucherID") || kos.guidEmpty,
                        captchaResponse: token
                    }, { wait: true }).done($def.resolve);
                });
            });
            return $def.promise();
        },

        forgotPassword: function () {
            var $def = new $.Deferred();
            api.forgotPassword({
                email: this.get('email')
               }, { wait: true }).done($def.resolve);
            return $def.promise();
        },

        setEmail: function (email) {
            if (email === this.get('email')) return;
            var isValid = validateEmail(email);
            this.set('isValid', isValid);
            this.set('email', email);
            this.set('token', null);
            this._receiveToken();
        },
        isValid: function() {
            return this.get('isValid');
        }
    });


    var TwoStepsView = Backbone.View.extend({
        el: '@customerEmail',
        model: new TwoStepsModel(),
        events: {
            'keyup #GuestEmail': '_changed', // Only for <=IE9.
            'change #GuestEmail': '_changed',
            'blur #GuestEmail': '_changed',

            'focus #GuestEmail': '_focus',
            'mouseup #GuestEmail': '_clearedByCross',

            'click @forgotPasswordBtn': '_forgotPassword',
            'click @btnSignin': '_signin',
            'click @displayLoginForm': '_displayLoginForm'
        },

        initialize: function () {
            _.bindAll(this);

            this.model.on('change:isValid', this._isValid);
            this.model.on('change:token', this._toggle);

            this.$agreeTC = $('@customerAgreeWithTC');
            this.$agreeEmails = $('@customerReceiveEmails');
            this.$agreementText = $('@agreementText');

            this.$agreeTC.remove();
            this.$agreeEmails.remove();

            var settings = CheckoutSettings.getBasketSettings();
            var isFacebookLoginEnabled = settings && settings.FacebookLoginEnabled || false;

            window.isFacebookLoginEnabled = isFacebookLoginEnabled;

            if (_IsAuthorized()) {
                this.$el.remove();
                this.$agreementText.remove();
            } else {
                this.$agreementText.html($.tmpl('guest_two_steps_agreement'));
                this.$el.html($.tmpl('guest_two_steps_auth', {
                    isFacebookLoginEnabled: isFacebookLoginEnabled,
                }));

                this.$field = this.$('#GuestEmail');
                this.$field.keyFilter();

                var currentEmail = getGuestEmail();
                if (currentEmail) {
                    this.$field.val(currentEmail);
                    this.model.setEmail(currentEmail);
                }

                if(isFacebookLoginEnabled){
                    this.initFacebookAuth();
                }

                this.initTC();

                var _this = this;
                setTimeout(function () {
                    _this.$field.focus();
                }, 2000);
            }
        },

        initTC: function() {
            var result = initializeTC(this._tcOnChange, this._emailOnChange);

            this.switchTC = result.switchTC;
            this.switchEmail = result.switchEmail;

            this.switchTC.appendTo(this.$agreeTC);
            this.switchEmail.appendTo(this.$agreeEmails);
        },

        initFacebookAuth: function() {
            this.facebook = new FacebookAuthorization({
                appId: GlobalSettings.Fid,
                authCallback: _.bind(this._fbAuthCallback, this),
                btnID: "@btnFacebookAuth"
            });  
        },

        _fbAuthCallback: function (data) {
            var invitedBy = window.cookie && cookie.get('invitedBy') || null;
            data = _.extend({}, data || {}, {
                referredBy: queryParams['referredby'] || null,
                invitedBy: invitedBy || queryParams['invitedby'] || null,
                voucherID: '00000000-0000-0000-0000-000000000000',
                password: null
            });
            api.loginFacebook(data, { wait: true }).done(this._success);
        },

        _signin: function () {
            var password = this.$('#CustomerPassword').val();
            var tcAccepted = this.switchTC.getValue();
            var emailsAccepted = this.switchEmail.getValue();
            this.model.signin(password, tcAccepted, emailsAccepted).done(this._success);
        },

        _forgotPassword: function () {
            var $el = this.$('@forgotPasswordBtn');
            var timeout = setTimeout(function () {
                $el.text('sending...');
            }, 500);

            this.model.forgotPassword().done(function () {
                clearTimeout(timeout);
                $el.text('Password sent to your email address');
            }).always(function () {
                setTimeout(function() {
                    $el.text(GetPageTemplate('_ForgotUsernamePassword'));
                }, 5000);
            });
        },

        _success: function () {
            var _this = this;
            return app.checkout.update_checkout(true).done(function () {
                window.__isAuthorized__ = true;
                window.isAuthorized = null;
                _this.switchTC.remove();
                _this.switchEmail.remove();
                _this.$el.remove();
                _this.$agreementText.remove();
                location.reload();
           }).fail(function () {
                location.reload();
            });
        },

        _displaySigninForm: function (display) {

            /* do not display signup form for new emails */
            if (!this.model.get('exists')) {
                display = false;
            }

            this.$('#CustomerPassword').attr('type', 'password');

            this.$('@forgotPasswordBtn').toggleClass('hidden-block', !this.model.get('exists'));
            this.$('@btnSignin').text(this.model.get('exists') ? GetPageTemplate('mobile_Login') : GetPageTemplate('_Signup'));


            this.$('@signinForm').toggleClass('hidden-block', !display);
            this.$('@signInButton').toggleClass('hidden-block', display);
            this.$('@guestText').toggleClass('hidden-block', !(!display && this.model.get('isValid')));
        },

        _tcOnChange: function () {
            if (this.switchTC) {
                var val = this.switchTC.getValue();
                window.app && app.event && app.event.userAgreementsTermsAndCondition(val);
                this.switchTC.toggleWarningClass(false);
            }
        },

        _emailOnChange: function () {
            if (this.switchEmail) {
                var val = this.switchEmail.getValue();
                window.app && app.event && app.event.userAgreementsReceivePromotional(val);
                this.switchEmail.toggleWarningClass(false);
            }
        },

        _toggle: function(m) {
            this._displaySigninForm(!!m.get('token'));
        },

        _isValid: function(m) {
            this.$field.toggleClass('emailErrorField', !m.isValid());
        },

        _changed: function(e) {
            var email = e.target.value;
            this.model.setEmail(email);
        },

        _focus: function () {
            //this.$field.removeClass('emailErrorField');
        },

        _clearedByCross: function (e) {
            var _this = this;
            if (e.currentTarget.value === "") return;
            setTimeout(function () {
                if (e.currentTarget.value === "") _this._validate();
            }, 0);
        },

        _displayLoginForm: function (e) {
            e.preventDefault();
            window.app && app.event && app.event.logIn();
            window.landingForm && landingForm.showPopup({ closeBtn: true, mode: landingForm.mode.Login })
                .done(function () {
                    landingForm.destroy();
                    location.reload();
                });
        },

        getCustomerData: function () {
            var email = this.model.get('email');
            var isValid = this.model.get('isValid');

            if (!isValid || !email) {
                this.$field.toggleClass('emailErrorField', true);
                isValid = false;
                email = null;
            }

            var name = '';

            if (app.models.delivery.current.isActive) {
                name = app.models.delivery.current.get('Name');
            } else if (app.models.delivery.decoration.isActive) {
                var models = app.models.delivery.decoration.where({ 'Name': 'Name' });
                name = models[0] && models[0].get('Value') || '';
            }

            var tcAccepted = this.switchTC.getValue();
            var emailsAccepted = this.switchEmail.getValue();

            var message = [];

            this.switchTC.toggleWarningClass(!tcAccepted);
            this.switchEmail.toggleWarningClass(emailsAccepted === null);

            !tcAccepted && message.push('- ' + GetPageTemplate('_consentWithRegistrationTermsWarning'));
            emailsAccepted === null && message.push('- ' + GetPageTemplate('_consentWithRegistrationEmailWarning'));

            if (message.length > 0) {
                kos.dialog.error({ title: '', message: message.join('</br>') });
            }

            return {
                email: isValid ? email : null,
                name: name,
                parameters: {
                    tcAccepted: tcAccepted,
                    emailsAccepted: emailsAccepted
                },
                isValid: isValid && tcAccepted && emailsAccepted !== null
            };
        }
    });
    
    return function() {
        var setting = app.settings.get('UseGuestCheckoutTwoSteps');
        var view = setting && TwoStepsView || CustomerEmailView;
        return new view();
    }

})(IsAuthorized);